<template>
  <div>
    <div class="score-history__item">
      <div class="column">
        <div class="column-block">
          <div class="top-part">
            <span class="order-type">{{ item.name }}</span>
          </div>
          <div class="spacer"></div>
          <div v-if="!isMobile" class="bottom-part order-status">
            <div class="bottom-block right-border">
              <span>Статус:</span>
              <div :class="['status', getStatusClass(item)]">
                <span>{{ showStatusName(item) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column">{{ item.agent }}</div>
      <div v-if="isMobile" class="column full-width">
        <div class="bottom-part order-status">
          <span>Статус:</span>
          <div class="bottom-block right-border">
            <div :class="['status', getStatusClass(item)]">
              <span>{{ showStatusName(item) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="column">{{ item.date }}</div>
      <div class="column">
        <div class="write-on-amount"> {{ item.sum }}</div>
      </div>
      <div class="column"><a target="_blank" :href="item.path">Акт</a>
        <a target="_blank" class="edited_path" v-if="item.edited_path" :href="item.edited_path">Змінений акт</a>
        <a target="_blank" class="signed_path" v-if="item.signed_path" :href="item.signed_path">Підписаний акт</a>
        <a target="_blank" class="signed_path"
           v-else-if="item.sign_url && (item.status_slug === 'checked' || item.status_slug === 'corrected')"
           :href="item.sign_url">Підписати документ</a>
      </div>
    </div>
  </div>

</template>

<script>
import FileInput from "@/components/app/forms/FileInput.vue";
import {mapGetters} from "vuex";

export default {
  name: 'RowBlockActs',
  components: {FileInput},
  computed: {
    ...mapGetters('layoutModule', ['isTablet', 'isMobile', 'windowWidth'])
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          id: null,
          amount: null,
          createdAt: null,
          currentAmount: null,
        };
      },
    },
  },
  methods: {
    getStatusClass(item) {
      return "status-" + item.status_slug;
    },
    showStatusName(item) {
      return item.status_name;
    },
  },
}
</script>
<style>
.score-history__item {
  display: flex;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .score-history__item .column {
    flex: 1 1 auto;
  }

  .score-history__item .column.full-width {
    flex: 0 0 100%;
    width: 100%;
  }
}

.score-history__item .column {
  height: 100%;
}

.score-history__item .bottom-part.order-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.score-history__item .column-block {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 54px;
  box-sizing: border-box;
}

.score-history__item .bottom-part {
  display: flex;
}

.bottom-block {
  display: flex;
  align-items: center;
}

.score-history__item .spacer {
  flex-grow: 1;
}

.score-history__item .status {
  height: auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  margin-left: 5px;
  background: #34393D;
  float: right;
  padding: 4px 10px;
  white-space: nowrap;
}

.score-history__item .status.status-sent {
  background: #ffad3d;
}

.score-history__item .status.status-new {
  background: #4da681;
}

.score-history__item .status.status-in_work {
  background: #fd7e14;
}

.score-history__item .status.status-checked {
  background: #50A64D;
}

.score-history__item .status.status-corrected {
  background: #ea6060;
}

.score-history__item .status.status-waiting_for_sign {
  background: #17a2b8;
}

.score-history__item .status.status-signed_by_agent {
  background: #e83e8c;
}

.score-history__item .status.status-paid {
  background: #891AF2;
}

.score-history__item .status.status-rejected {
  background: #E52C25;
}

.score-history__item .status span {
  margin: 0 6px;
  height: 21px;
  font-family: Circe;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: #FFFFFF;
}

.score-history__item .edited_path {
  display: block;
  margin-top: 5px;
  color: #891AF2;
  font-weight: bold;
}

.score-history__item .signed_path {
  display: block;
  margin-top: 5px;
  color: #e83e8c;
  font-weight: bold;
}
</style>
